import yup from './yup'
import moment from 'moment-timezone'
import { AnnouncementStatus } from 'constants/index'
import { isEditorContentEmpty } from './setting'

export const announcementFormSchema = yup.object().shape({
  announcementText: yup
    .string()
    .label('Announcement Text')
    .trimmedRequired('Announcement Text is required')
    .test(
      'is-not-empty',
      'Announcement Text cannot be empty',
      (value) => !isEditorContentEmpty(value)
    ),
  recipients: yup
    .array()
    .of(yup.string())
    .min(1, 'At least one recipient is required')
    .required('Recipients are required'),
  status: yup.string(),
  isScheduled: yup.boolean(),
  scheduledOn: yup.mixed().when('isScheduled', {
    is: true,
    then: yup
      .date()
      .typeError('Invalid date')
      .required('Schedule Date Time is a required field.')
      .test('date time check', 'Schedule Date Time must be after Current Time', function (value) {
        const status = this.parent.status
        if (status === AnnouncementStatus.SCHEDULED) {
          const nowDateTime = moment()
          return nowDateTime.isSameOrBefore(moment(value))
        } else return true
      }),
    otherwise: yup.mixed().nullable()
  })
})
